import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'sim-detail-field',
  imports: [],
  templateUrl: './detail-field.component.html',
  styleUrl: './detail-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'detail-field'
  }
})
export class SimDetailFieldComponent {
  readonly label = input<string>('');
  readonly truncate = input(false, { transform: booleanAttribute });
}
